import decrypt from "../services/hash-service/decrypt-service";

const getUserData = () => {
  const user = decrypt(localStorage.getItem("User"));
  const token = localStorage.getItem("Token");
  const selectedProject = decrypt(localStorage.getItem("selectedProject"));
  const modulesVal = decrypt(localStorage.getItem("modules"));
  
  return {
    user: user,
    token,
    selectedProject:
      selectedProject !== "undefined" ? selectedProject : [],
    modules: modulesVal !== "undefined" ? modulesVal : [],
  };
};

export default getUserData;
